<template>
  <div class="loading cols justify-center align-items-center">
    <img alt="Loading" src="@/assets/images/loading.gif">
  </div>
  <div v-if="this.message" class="cols justify-center align-items-center loading-message font-size-20 text-white"
       v-html="this.message">
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    message: [String, null]
  }
};
</script>

<style scoped lang="scss">
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background: black;
  opacity: 0.3;
  z-index: 99999;
}

.loading-message {
  position: fixed;
  top: 100px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100000;
  font-weight: bold;
}
</style>
